const SVG_NAMESPACE = 'http://www.w3.org/2000/svg'
const VIEW_BOX = '0 0 24 24'

export const createIcon = (paths: string[]): SVGSVGElement => {
  const icon = document.createElementNS(SVG_NAMESPACE, 'svg')
  icon.setAttribute('viewBox', VIEW_BOX)
  icon.setAttribute('fill', 'none')
  icon.setAttribute('stroke', 'currentColor')
  icon.setAttribute('stroke-width', '2')
  icon.setAttribute('stroke-linecap', 'round')
  icon.setAttribute('stroke-linejoin', 'round')
  icon.setAttribute('aria-hidden', 'true')

  paths.forEach(path => {
    const segment = document.createElementNS(SVG_NAMESPACE, 'path')
    segment.setAttribute('d', path)
    icon.append(segment)
  })

  return icon
}
